import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon/FuseSvgIcon';
import {AppButton, AppButtonVariant} from '@/app/shared-components/AppButton';
import {ButtonContainer} from '@/app/shared-components/ButtonContainer';
import {IMAGES} from '@/constants/images';
import {COLORS} from '@/styles/colors';

import {
  LinkExpiredProvider,
  useLinkExpiredViewModel,
} from './LinkExpiredViewModel';

import './styles';

const LinkExpiredContent = () => {
  const {t} = useTranslation();
  const {handleOpenDownloadApp, showVariant} = useLinkExpiredViewModel();

  return (
    <Box className="link-expired-container">
      <Box
        className="logo"
        component="img"
        src={IMAGES.LOGO_TEXT_BLACK.src}
        alt="Logo"
      />
      <Box className="link-expired-container-content">
        <Box className="link-expired-container-content-image">
          <Box
            className="password-changed-container-icon"
            component="img"
            src={IMAGES.EXCLAMATION.src}
            width={IMAGES.EXCLAMATION.width}
            height={IMAGES.EXCLAMATION.height}
            alt="Exclamation"
          />
        </Box>
        <Box className="link-expired-container-content-text">
          <Typography className="link-expired-container-content-text-title">
            {showVariant
              ? t('link_expired_page.title_variant')
              : t('link_expired_page.title')}
          </Typography>
          <Typography className="link-expired-container-content-text-subtitle">
            {showVariant
              ? t('link_expired_page.sub_title_variant')
              : t('link_expired_page.sub_title')}
          </Typography>
        </Box>
      </Box>
      <ButtonContainer sticky>
        <AppButton
          id="link-expired-download-app-button"
          iconRight={
            <FuseSvgIcon
              size={12}
              sx={{color: COLORS.WHITE}}>
              heroicons-outline:arrow-up-right
            </FuseSvgIcon>
          }
          label={t('link_expired_page.button')}
          onClick={handleOpenDownloadApp}
          variant={AppButtonVariant.onPrimary}
        />
      </ButtonContainer>
    </Box>
  );
};

const LinkExpiredPage = () => (
  <LinkExpiredProvider>
    <LinkExpiredContent />
  </LinkExpiredProvider>
);

export default LinkExpiredPage;
